// src/pages/auth/ForgotPasswordPage.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { resetPassword } from "../../services/authService";
import Button from "../../components/ui/Button";
import Input  from "../../components/ui/Input";
import styles from "./AuthPages.module.css";

export default function ForgotPasswordPage() {
  const [email, setEmail]     = useState("");
  const [message, setMessage] = useState("");
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault(); setError(""); setMessage(""); setLoading(true);
    try { await resetPassword(email); setMessage("Check your inbox — a reset link is on its way."); }
    catch { setError("Could not send reset email. Is the address correct?"); }
    finally { setLoading(false); }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.brand}>
          <span className={styles.logo}>GS</span>
          <h1 className={styles.title}>Gigscout</h1>
        </div>
        <h2 className={styles.heading}>Reset password</h2>
        <p className={styles.sub}>We'll send you a link to reset it</p>
        {error   && <div className={styles.errorBanner}>{error}</div>}
        {message && <div className={styles.successBanner}>{message}</div>}
        <form onSubmit={handleReset} className={styles.form}>
          <Input label="Email" id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@example.com" required />
          <Button type="submit" fullWidth loading={loading}>Send Reset Link</Button>
        </form>
        <p className={styles.footer}><Link to="/login">← Back to Sign In</Link></p>
      </div>
    </div>
  );
}
